<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
    <v-text-field
      block
      :label="$t('register.phoneNumber')"
      outlined
      type="number"
      v-model="form.phoneNumber"
      :rules="rules.phoneNumber"
      data-cy="register-phoneNumber"
      :prepend-inner-icon="mdiPhone"
    />
    <v-alert type="error" v-for="error in errors" :key="error">
      {{ error }}
    </v-alert>
    <v-btn
    class="primary mb-2 rounded-0 text-capitalize block"
    block
    :loading="isLoading"
    type="submit"
    data-cy="register-requestOtp"
  >
    {{ $t('register.requestOtp') }}
  </v-btn>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import { mdiPhone } from '@mdi/js';
import authMixins from './auth-mixins';

export default {
  mixins: [authMixins, loading],
  name: 'FormOtp',
  data() {
    return {
      mdiPhone,
      valid: true,
      form: {
        phoneNumber: '',
        errors: [],
      },
    };
  },
  methods: {
    async sendOtp() {
      this.isLoading = true;
      await this.$http.post('/join', {
        phoneNumber: this.form.phoneNumber,
      });
      this.isLoading = false;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.form.errors = [];
        try {
          await this.sendOtp();
          this.$emit('sent', this.form);
        } catch (error) {
          const { response } = error;
          const { request, ...errorObject } = response; //
          if (errorObject.status === 400) {
            this.errors = [this.$t(errorObject.data?.message ?? 'common.error.basic')];
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
